<template>
  <div class="menber">
    <!-- 头部 -->
    <div class="top">
      <div class="header">
        <a href="https://gdtvshop.weixinmvp.com/wap/shop/MemberDefault.aspx" class="h_portrait">
          <img :src="menImg" :onerror='errorImg' alt="">
        </a>
        <a href="https://gdtvshop.weixinmvp.com/wap/shop/MemberDefault.aspx" class="uname"> {{menName}}</a>
        <div class="menber_date" v-if="endTime">V卡会员到期日：{{endTime}}</div>
        <div class="info_edit">
          <router-link to="/editinfo">
            <img src="../../../assets/images/edit.png" alt="">
            <p>信息修改</p>
          </router-link>
        </div>
      </div>
      <div class="open_btn" >
        <button class="old_btn" @click="IsPay">
          <span class="open_txt">{{openTxt}}</span>
          <span class="open_money" v-if='isMoney'>¥{{Price}}/年</span>
        </button>
        <button v-if="istime" class="new_btn" @click="V_Tiyan()">
          <span class="open_money">38元V卡体验</span>
        </button>
      </div>
    </div>
    <!-- 会员特权 -->
    <div class="privilege">
      <img src="../../../assets/images/2-1.png" alt="">
    </div>

  </div>
</template>

<script>
import MbrService from "../../../services/mbrservice.js";
import cardService from "../../../services/card-service.js";
export default {
  data() {
    return {
      istime: false,
      Price: "",
      openTxt: "立即开通",
      endTime: "",
      menName: "",
      menImg: "",
      isMoney: true,
      errorImg:
        'this.src="' + require("../../../assets/images/HeadPortrait.jpg") + '"'
    };
  },
  methods: {
    getMembershipPrice() {
      new cardService().getCardInfo({}).then(res => {
        if (res.ErrorCode == 0) {
          this.Price = res.Data.SalePrice;
        }
      });
    },
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = date.getFullYear() + "" + month + "" + strDate;

      return currentdate;
    },
    IsBind() {
      var _this = this;
      new MbrService().isBind().then(res => {
        if (res.ErrorCode == -2) {
          //未登录
        } else if (res.ErrorCode == 0) {
          //登录过
          this.LaodMemberInfo();
          if (res.Data.IsBuy == 0) {
            //没有购买
            //判断有没有绑定信息
            if (res.Data.IsBind == 0) {
            }
          } else if (res.Data.IsBuy == 1) {
            //购买过了
            //判断是否过期
            var timeSrc = res.Data.EndTime.replace(" ", "T");
            if (new Date(timeSrc).getTime() < new Date().getTime()) {
              this.openTxt = "续费";
              this.endTime = res.Data.EndTime;
            } else {
              // 现有逻辑是只要会员有效期内就显示“提前续费”。
              this.openTxt = "提前续费";
              this.endTime = res.Data.EndTime;

              // 这个是之前的逻辑，判断会员有效期在一年之内显示“提前续费”，大于等于一年则显示“已开通”。
              // var Year = new Date().getFullYear() + 1;
              // var Month = (new Date().getMonth()+1)<10?'0'+(new Date().getMonth()+1):(new Date().getMonth()+1);
              // var Day = new Date().getDate()<10?'0'+new Date().getDate():new Date().getDate();
              // var Hours = new Date().getHours()<10?'0'+new Date().getHours():new Date().getHours();
              // var Seconds = new Date().getSeconds()<10?'0'+new Date().getSeconds():new Date().getSeconds();
              // var Minutes = new Date().getMinutes()<10?'0'+new Date().getMinutes():new Date().getMinutes();
              // var nowtime =Year +"-" +Month +"-" +Day +"T" +Hours +":" +Minutes +":" +Seconds;
              // if (new Date(nowtime).getTime() > new Date(timeSrc).getTime()) {
              //   this.openTxt = "提前续费";
              //   this.endTime = res.Data.EndTime;
              // } else {
              //   this.openTxt = "已开通";
              //   this.endTime = res.Data.EndTime;
              //   var newData = this.getNowFormatDate();
              //   this.isMoney = false;
              // }
            }
          }
        }
      });
    },
    // 点击购买会员
    IsPay() {
      if (this.openTxt != "已开通") {
        this.$router.push({ path: "/pay", query: {proNo: "MB1520320312462"} });
      }
    },
    // 点击购买V卡体验
    V_Tiyan() {
      this.$router.push({ path: "/pay", query: {proNo: "MB1520320312464"} });
    },
    // 获取会员信息
    LaodMemberInfo() {
      var _this = this;
      new MbrService().LaodMemberInfo().then(res => {
        if (res.ErrorCode == 0) {
          this.menName = res.Data.Name;
          this.menImg = "";
          this.menImg = this.$util(res.Data.PhotoUrl);
          if (!this.menImg) {
            this.menImg = "../../../assets/images/HeadPortrait.jpg";
          }
        }
      });
    }
  },
  created: function() {
    const time5 = new Date("2020/03/05"); 
    const time8 = new Date("2020/03/09"); 
    const Ntime = new Date(); 
    // 当前时间大于5号并且小于9号的时候，显示38元购买V卡按钮
    if(Ntime.getTime() >= time5.getTime() && Ntime.getTime() < time8.getTime()){
      this.istime = true
    } else {
      this.istime = false
    }
    this.getMembershipPrice();
    this.IsBind();
  }
};
</script>

<style scoped>
.top {
  position: relative;
}

.header {
  background: url("../../../assets/images/headerbg.png") no-repeat;
  background-size: cover;
  margin: 0.3rem;
  overflow: hidden;
  box-shadow: -0.02rem 0.05rem 18px 0px #1a2a292b;
  border-radius: 0.2rem;
  padding-bottom: 1rem;
  position: relative;
}

.header .h_portrait {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  overflow: hidden;
  margin: 0.3rem auto;
  display: block;
}

.header .uname {
  text-align: center;
  font-size: 0.38rem;
  color: rgba(255, 226, 177, 0.82);
  text-decoration: none;
  display: block;
}

.header .menber_date {
  text-align: center;
  font-size: 0.24rem;
  color: #6d6d6d;
  margin-top: 0.1rem;
}

.header .info_edit {
  position: absolute;
  text-align: center;
  font-size: 0.2rem;
  top: 0.2rem;
  right: 0.3rem;
}

.header .info_edit a {
  color: rgba(238, 217, 175, 0.8);
  text-decoration: none;
  display: block;
}

.header .info_edit img {
  width: 0.5rem;
}

.top .open_btn {
  position: absolute;
  width: 100%;
  bottom: -0.45rem;
  height: 0.9rem;
  display: flex;
  justify-content: space-around;
  padding: 0 4%;
  overflow: hidden;
  box-sizing: border-box
}

.top .open_btn button {
  height: 0.9rem;
  color: #fff;
  font-size: 0.32rem;
  border: none;
  border-radius: 0.2rem;
  outline: none;
  box-shadow: -0.02rem 0.05rem 18px 0px #1a2a292b;
}
.top .open_btn .old_btn{
  /* position: absolute; */
  /* left: 50%; */
  /* transform: translateX(-50%); */
  background: #ffce59;
  width: 59%;
  color: #313336;
}
.top .open_btn .new_btn{
  /* position: absolute; */
  width: 36%;
  background: #f1d3a1;
  /* left: 50%; */
  /* transform: translateX(-50%); */
}

.privilege {
  padding: 0.5rem 0.2rem 0rem 0.2rem;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/component/home/member/Member.vue